import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyVertical = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 6.66667C8.55556 6.66667 9.02778 6.47223 9.41667 6.08334C9.80556 5.69445 10 5.22223 10 4.66667C10 4.11112 9.80556 3.63889 9.41667 3.25001C9.02778 2.86112 8.55556 2.66667 8 2.66667C7.44444 2.66667 6.97222 2.86112 6.58333 3.25001C6.19444 3.63889 6 4.11112 6 4.66667C6 5.22223 6.19444 5.69445 6.58333 6.08334C6.97222 6.47223 7.44444 6.66667 8 6.66667ZM8.03333 15.3333L5.33333 12.6667L6.66667 11.3333L5.33333 10L6.66667 8.66667V8.43334C5.86667 8.15556 5.22222 7.67223 4.73333 6.98334C4.24444 6.29445 4 5.52223 4 4.66667C4 3.55556 4.38889 2.61112 5.16667 1.83334C5.94444 1.05556 6.88889 0.666672 8 0.666672C9.11111 0.666672 10.0556 1.05556 10.8333 1.83334C11.6111 2.61112 12 3.55556 12 4.66667C12 5.56667 11.7444 6.35278 11.2333 7.02501C10.7222 7.69723 10.0889 8.16667 9.33333 8.43334V14L8.03333 15.3333Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgKeyVertical);
export default ForwardRef;
